// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import React from "react";
import { IAssetPreviewProps } from "./assetPreview";
import { loadImageToCanvas } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import { parseEndpointByType } from "../jsonSchemaFormHelper";
import axios from "axios";

interface IImageAssetState {
    imageUri: string;
}

/**
 * ImageAsset component used to render all image assets
 */
export class ImageAsset extends React.Component<IAssetPreviewProps, IImageAssetState> {
    private image: React.RefObject<HTMLImageElement> = React.createRef();

    constructor(props: IAssetPreviewProps) {
        super(props);

        this.state = {
            imageUri: null,
        };
    }

    public async componentDidMount() {
        if (this.props.asset != null) {
            // const canvas = await loadImageToCanvas(this.props.asset.path);
            // this.setState({
            //     imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedThumbnailQuality),
            // });
            if (this.props.asset.cachedImage) {
                this.setState({
                    imageUri: this.props.asset.cachedImage,
                });
            } else {
                await this.getThumbnail(this.props.asset);
                //setTimeout(() => {
                //    this.loadPdfFile(this.props.asset.path);
                //}, 1000);
            }
        }
    }

    private getThumbnail = async (asset) => {
        const res = await axios.get(parseEndpointByType("GetProjectAssetThumbnail") + `?url=${encodeURIComponent(asset.path)}`);
        this.checkAndGetImage(res.data);        
    }

    private checkAndGetImage(imageUri) {
        const self = this;
        setTimeout(function () {
            var http = new XMLHttpRequest();

            http.open('HEAD', imageUri, false);
            http.send();

            if (http.status != 404) {
                self.setState({
                    imageUri: imageUri
                });
            }
            else {
                self.checkAndGetImage(imageUri)
            }
        }, 1000);
    }

    public render() {
        return (
            <img ref={this.image}
                src={this.state.imageUri}
                alt={this.props.asset.name}
                onLoad={this.onLoad}
                onError={(e) => {
                    this.props.onError(e);
                }}
                crossOrigin="anonymous" />);
    }

    private onLoad = () => {
        if (this.props.onLoaded) {
            this.props.onLoaded(this.props.asset, this.image.current);
        }
        if (this.props.onActivated) {
            this.props.onActivated(this.image.current);
        }
        if (this.props.onDeactivated) {
            this.props.onDeactivated(this.image.current);
        }
    }
}
